export const EnglishTranslation = {
  companyName: "Coke loyalty",
  login: {},
};
